<template>
  <div class="tipText">
    <i class="icon_warning"></i>
    <span :style="{ color }">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    },
    color: {
      type: String,
      default: "#6e6e6e"
    }
  }
};
</script>

<style scoped lang="scss">
.tipText {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #6e6e6e;
  line-height: 30px;
  .icon_warning {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png");
    background-size: cover;
    position: relative;
    top: 3px;
    width: 15px;
    height: 15px;
    display: inline-block;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TipText.vue